module.exports = __webpack_public_path__ + "img/Tablet - 6.c39bb962.png";